/** The texts of checks (ANN-32, ANN-33) and their filters (COL-02), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const checksEn = {
  checkUnchecked: 'Unchecked',
  checkCheckedTimes: 'Checked {count} times',
  checkCheckedTimes_one: 'Checked once',
  checkHere: 'Check this study now: every view must have been shown',
  checkHow: 'Press {key} twice, or double-click the next study, to check a study as you leave it.',
  checkTwice: 'twice quickly: check this study',
  checkNoteChecked: 'Study checked, {count} times',
  checkNoteChecked_one: 'Study checked',
  checkNoteUnseen: 'Not checked: {count} of {total} views not seen',
  checkNoteUnseen_one: 'Not checked: 1 of {total} views not seen',
  checkNoteFailed: 'Not checked: the check could not be saved',
  checkNoteUndone: 'Check undone',
  checkNoteRefused: 'Not checked: {reason}',
  checkUndo: 'Undo',
  finishStudy: 'Finish study',
  finishStudyHelp: 'Checks the study once every view has been shown, and finishes it in the job. Or press {key} twice as you leave it.',
  reopenStudy: 'Reopen study',
  conditionChecked: 'a check',
  conditionCheckedTimes: '{count} checks',
  conditionCheckedUsers: 'checks by {count} users',
  queryCheckCount: 'At least',
  change_checked: 'checks: {count}',
}

export const checksDe: Record<keyof typeof checksEn, string> = {
  checkUnchecked: 'Ungeprüft',
  checkCheckedTimes: '{count}-mal geprüft',
  checkCheckedTimes_one: 'Einmal geprüft',
  checkHere: 'Diese Studie jetzt prüfen: Jede Ansicht muss gezeigt worden sein',
  checkHow: 'Drücken Sie {key} zweimal oder doppelklicken Sie auf die nächste Studie, um eine Studie beim Verlassen zu prüfen.',
  checkTwice: 'zweimal schnell: diese Studie prüfen',
  checkNoteChecked: 'Studie geprüft, {count}-mal',
  checkNoteChecked_one: 'Studie geprüft',
  checkNoteUnseen: 'Nicht geprüft: {count} von {total} Ansichten nicht gesehen',
  checkNoteUnseen_one: 'Nicht geprüft: 1 von {total} Ansichten nicht gesehen',
  checkNoteFailed: 'Nicht geprüft: Die Prüfung ließ sich nicht speichern',
  checkNoteUndone: 'Prüfung zurückgenommen',
  checkNoteRefused: 'Nicht geprüft: {reason}',
  checkUndo: 'Rückgängig',
  finishStudy: 'Studie abschließen',
  finishStudyHelp: 'Prüft die Studie, sobald jede Ansicht gezeigt wurde, und schließt sie im Auftrag ab. Oder drücken Sie {key} zweimal beim Verlassen.',
  reopenStudy: 'Studie wieder öffnen',
  conditionChecked: 'Prüfung',
  conditionCheckedTimes: '{count} Prüfungen',
  conditionCheckedUsers: 'Prüfungen von {count} Personen',
  queryCheckCount: 'Mindestens',
  change_checked: 'Prüfungen: {count}',
}
